import { createTheme } from '@mui/material/styles';
import { pageColors } from '../HomePage';

export const CRM_DASHBOARD_THEME = createTheme({
  palette: {
    primary: {
      main: pageColors.crm,
    },
  },
  typography: {
    fontFamily: 'Inter, Roboto, sans-serif',
  },
});

export const PAGE_BACKGROUND =
  'radial-gradient(circle at top left, rgba(0,121,107,0.16), transparent 55%), #f5f7fb';

export const SURFACE_SX = {
  borderRadius: 4,
  backgroundColor: '#fff',
  boxShadow: '0 18px 40px rgba(0,0,0,0.07)',
  border: '1px solid rgba(0,0,0,0.05)',
};

export const BADGE_SX = {
  display: 'inline-flex',
  alignItems: 'center',
  minHeight: 24,
  px: 1,
  borderRadius: '999px',
  border: '1px solid transparent',
  fontSize: '0.75rem',
  fontWeight: 600,
  lineHeight: 1.1,
};

export const CONTENT_GRID_SX = {
  display: 'grid',
  gridTemplateColumns: {
    xs: 'minmax(0, 1fr)',
    md: 'repeat(3, minmax(0, 1fr))',
  },
  gap: 2,
  alignItems: 'start',
};

export const CONTENT_GRID_ITEM_SX = {
  minWidth: 0,
};

export const CLAMP_TWO_LINES_SX = {
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
};

export const CLAMP_ONE_LINE_SX = {
  display: '-webkit-box',
  WebkitLineClamp: 1,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
};
